// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import global components
import Spinner from '../../../global/components/helpers/Spinner.jsx';
import { usePageTitle } from '../../../global/utils/customHooks.js';

/**
 * Wraps all non-admin User components in a default view wrapper.
 * @param title - the title of the page (shows up on the browser tab)
 * @param className - the className to apply to the wrapper
 */
const UserLayout = ({ title, children, className = 'bg-neutral-pri w-full min-h-screen pt-10 md:pt-20' }) => {

  usePageTitle(title ? `${title} | Simulations Plus` : "User | Simulations Plus");

  return (
    <div className={className}>
      {children}
    </div>
  )
}

UserLayout.Skeleton = (props) => {
  return (
    <UserLayout {...props}>
      <Spinner />
    </UserLayout>
  )
}

UserLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node)
    , PropTypes.node
  ]).isRequired
  , className: PropTypes.string
  , title: PropTypes.string
}
const LOGO_SRC = "https://pro-ficiency-static.s3.us-east-2.amazonaws.com/atlas/slp_full_blue.png"

export const Container = ({ children, title }) => {
  return (
    <div className='w-full flex flex-col gap-8'>
      <div className='flex justify-start'>
        <img className="w-auto h-auto max-h-[40px]" src={LOGO_SRC} alt='logo' />
      </div>
      <h1 className='text-neutral-sec text-5xl m-0'> {title} </h1>
      {children}
    </div>
  )
}

export default UserLayout;

